<template>
  <div class="container">
    <div class="top-label">
      <span>TCP
        <span class="refresh-icon" @click="getList()"><i :class="{'fas fa-sync-alt':true, 'fa-spin':staging.loading}"></i> <span class="tooltiptext">Refresh</span></span>
      </span>
    </div>
    <div class="driver-container">
      <div class="staging-lots">
        <div class="filter-container">
          <select name="tcp-staging-list" class="filter-staging" v-model="stagingType">
            <option value="all">ALL</option>
            <option v-for="(stagingList, key) in stagingLists" :key="key" :value="stagingList.id">{{stagingList.name}}</option>
          </select>
        </div>
      <div class="loader" v-show="staging.loading">
        <i class="fa fa-spinner fa-spin"></i>
      </div>
      <div class="staging-area-error" v-show="staging.error">
        There are no drivers listed in TCP.
      </div>
    </div>
      <div class="driver-list" v-if="driversDisplayed !== null">
      <div class="service-drivers" v-for="(value, key) in driversDisplayed" v-if="checkLicense(value)">
        <div class="service-title" v-if="value.length > 0">
          <span v-if="key === 'shared'">Shared Ride</span>
          <span v-else-if="key === 'opoli'">Direct Non-Stop</span>
          <span v-else-if="key === 'black'">Sedan</span>
          <span v-else-if="key === 'suv'">SUV</span>
          <span v-else-if="key === 'shuttle'">Private Van</span>
          <span v-else>{{ getServiceName(value[0].serviceTypeId) }}</span>
        </div>
        <table v-if="value.length > 0">
          <tbody>
            <tr class="driver" v-for="queue in value" v-if="queue.provider.providerAccountType=='tcp'">
              <td><input type="radio" :value="queue.provider.ID+'-'+key" v-model="selectedDriver"></td>
              <td width="160">
                <a :href="'#/provider/' + queue.provider.ID" target="_blank">
                  {{ queue.provider.firstName }} {{ queue.provider.lastName }}
                </a>
              </td>
              <td>{{ queue.seatCapacity }} PAX </td>
              <td>{{ queue.status }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import ApiServices from '@/modules/api/services'
const merge = require('deepmerge')

export default {
  name: "driver-tcp",
  data () {
    return {
      staging: {
        selected: -1,
        loading: false,
        list: [],
        error: false
      },
      drivers: null,
      driversDisplayed: null,
      refreshing: false,
      driversPerLicense: []
    }
  },
  computed: {
    selectedDriver: {
      get () { return this.$store.state.laxit.selectedDriver },
      set (value) { this.$store.commit('laxit/setSelectedDriver', value) }
    },
    stagingType: {
      get () { return this.$store.state.laxit.driverTCP.stagingType },
      set (value) {
        this.staging.error = false
        this.$store.commit('laxit/setDriverTCPstagingType', value)
        this.getList()
      }
    },
    stagingLists() {
        let obj = this.$store.state.laxit.stagingLists;
        let keys = Object.keys(obj);
        let sorted = {}
        keys.sort(function(a, b) { return obj[a].priority - obj[b].priority });
        for (let i in keys) {
          sorted[i] = obj[keys[i]]
        }
        return sorted
      }
  },
  methods: {
    checkLicense(drivers) {
      if(drivers.length > 0) {
        for(let i=0; i < drivers.length; i++) {
          if(drivers[i].provider.providerAccountType == 'tcp') {
            return true
          }
        }
      } else {
        return false
      }

    },
    generateDrivers (items) {
      let self = this
      self.drivers = {}
      self.driversDisplayed = null

      for (let i = 0; i < items.length; i++) {
        let item = items[i]
        if (items[i].serviceTypeId <= 5) { continue }

        if (!self.drivers.hasOwnProperty(item.geofenceId)) {
          self.drivers[item.geofenceId] = {
            shared: [],
            opoli: [],
            black: [],
            suv: [],
            shuttle: []
          }
        }

        if (!self.drivers[item.geofenceId][item.serviceCode]) {
          self.drivers[item.geofenceId][item.serviceCode] = []
        }
        if (self.drivers[item.geofenceId][item.serviceCode].findIndex(x => x.provider.ID === item.provider.ID) === -1) {
          self.drivers[item.geofenceId][item.serviceCode].push(item)
        }
      }
    },
    getList () {
      let self = this
      self.staging.loading = true
      self.staging.list = []
      self.staging.error = false
      self.drivers = null
      self.driversDisplayed = null
      self.driversPerLicense = []
      self.$sdk.get('/airports/' + CONFIG.default.laxAirportId + '/staging', {
        token: self.$store.state.session.sessionToken
      }, r => {
        self.staging.loading = false
        if (r.error) {
          self.staging.error = true
          return
        }
        if (r.queue.length <= 0) {
          self.staging.error = true
        }
        self.staging.list = r.staging

        for (let i = 0; i < r.queue.length; i++) {
          if (!r.queue[i].serviceCode) {
            r.queue[i].serviceCode = self.getServiceName(r.queue[i].serviceTypeId)
          }
          if(r.queue[i].provider.providerAccountType=='tcp') {
            self.driversPerLicense.push(r.queue[i])
          }
        }

        if (self.driversPerLicense.length <= 0) {
          self.staging.error = true
        }

        self.generateDrivers(self.driversPerLicense)
        if(self.stagingType==='all') {
          let obj = self.drivers;
          let keys = Object.keys(obj);
          let sorted = {}
          keys.sort(function(a, b) {
            let index = ''
            for(let i in obj[a]) {
              if(obj[a][i].length > 0) {
                index = i
                break
              }
            }
            let index2 = ''
            for(let i in obj[b]) {
              if(obj[b][i].length > 0) {
                index2 = i
                break
              }
            }
            return obj[a][index][0].geofencePriority - obj[b][index2][0].geofencePriority });
          for (let i in keys) {
            sorted[i] = obj[keys[i]]
          }
          let driversList = {}
          let driverArray = []
          for (let driver in sorted) {
            driverArray.push(sorted[driver])
          }
          if(driverArray.length > 1) {
            driversList = merge(...driverArray)
            self.driversDisplayed = driversList
          } else {
            self.driversDisplayed = driverArray[0]
          }

        } else {
          if(!!self.drivers[self.stagingType]) {
            self.driversDisplayed = self.drivers[self.stagingType]
          } else {
            self.staging.error = true
          }
        }
      })
    },
    getServiceName (id) {
      let service = this.$store.state.services.list.filter(x => x.id === id)
      let brand = ''
      if (service.length) {
        brand = '[' + CONFIG.brands.filter(x => x.id === service[0].brandId)[0].code.toUpperCase() + '] '
      }
      return service.length ? brand + service[0].name : 'Cannot find service data...'
    }
  },
  mounted () {
    let self = this
    self.getList()
  }
};
</script>

<style lang="scss" scoped>
.container {
  border: 1px solid rgba(0, 0, 0, 0.1);
  position: relative;

  .top-label {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #0d79f2;
    color: #fff;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);

    .refresh-icon {
      i{ margin-left: 5px; }
      .tooltiptext {
        visibility: hidden;
        width: 80px;
        background-color: #4e4e4e;
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 1px 0;
        position: absolute;
        z-index: 1;
        opacity: 0;
        transition: opacity .6s;
        top: 120%;
        left: 60%;
        font-size: 14px;
      }
      &:hover {
        cursor: pointer;
        color: #26D97A;

        & .tooltiptext {
          opacity: 1;
          visibility: visible;
        }
      }
    }
  }

  .driver-container {
    overflow-y: auto;
    margin-top: 30px;
    height: calc((100vh - 110px) / 2);
    padding: 10px;

    .filter-container {
      text-align: right;

      .filter-staging {
        width: auto;
        margin-bottom: 8px;
      }
    }

    table {
      width: 100%;
      border-collapse: collapse;

      tr:nth-child(even) {
        background-color: #f3f3f3;
      }
      td {
        font-size: 12px;
        padding: 5px;
        text-align: center;
      }
      tr:hover {
        background-color: #fff8dc;
      }
    }
  }
}

.staging-lots {

  & .loader {
    text-align: center;
    font-weight: 700;
    padding: 15px;
  }
}

.staging-area-error {
  text-align: center;
  padding: 20px 0;
  font-weight: 700;
  color: #F20D0D;
}

.driver-list {
  margin-top: 8px;

  & .service-drivers {
    position: relative;
  }

  & .service-title {
    font-size: 12px;
    font-weight: 700;
    color: #0D79F2;
    margin-bottom: 3px;
  }
}

table{
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 10px;
}

.table-header{
  color: #8DA0A9;
  font-size: 12px;
  border: 1px solid rgba(0,0,0,0.3);
  background-color: #f5f5f5;

  & th{ padding: 5px 10px;  }
}

.driver{
  background-color: #fff;
  border: 1px solid rgba(0,0,0,0.3);
  position: relative;

  & td{
    padding: 10px;
    text-align: center;
    font-size: 12px;
    margin-bottom: 5px;

    & input{
      margin-top: 0;
      width: 13px;
    }
  }

  & a{ font-weight: 700; }
}

</style>



// WEBPACK FOOTER //
// src/components/Laxit/DriverTcp.vue